import React, { Fragment } from "react";
import Footer from "../components/Footer";
import Ads from "../components/publicaciones-home/Ads";
import CtaHome from "../components/home/content/CtaHome";
import DescargarApp from "../components/home/content/DescargarApp";
import { HomeHeader } from "../components/home/header/homeHeader";
import "../App.css";

const Home = () => {
  return (
    <Fragment>

      <HomeHeader/>

      <Ads />
      
      <CtaHome/>
      <DescargarApp/>
      <Footer />
      
    </Fragment>
  );
};

export default Home;
